import type { Scene } from "../engine/scene/SceneManager";
import type { Game } from "../game/Game";
import { RNG, randomSeed } from "../game/RNG";
import { ChampionSelectScene } from "./ChampionSelectScene";
import { AchievementsScene } from "./AchievementsScene";
import { MapScene } from "./MapScene";
import { HallOfFameScene } from "./HallOfFameScene";

export class MainMenuScene implements Scene {
  private root: HTMLDivElement;

  constructor(private game: Game) {
    this.root = document.createElement("div");
    this.root.className = "menu-screen";
  }

  enter(): void {
    this.game.sceneRoot.appendChild(this.root);
    this.buildButtons();
  }

  private buildButtons(): void {
    const hasSave = this.game.hasSavedRun();
    const stats = this.game.achievements.store.stats;
    const canHard       = stats.hardUnlocked       === true;
    const canImpossible = stats.impossibleUnlocked === true;

    this.root.innerHTML = `
      <div class="menu-header">
        <div class="menu-title">LoL ROGUE</div>
        <div class="menu-subtitle">TACTICAL HEX ROGUELIKE</div>
      </div>
      <div class="menu-play-section">
        ${hasSave ? `<button class="btn menu-btn-primary" id="continue-btn">▶ CONTINUE RUN</button>` : ""}
        ${hasSave ? `<div class="menu-divider">— OR START NEW —</div>` : ""}
        <button class="btn ${hasSave ? "menu-btn-new-run" : "menu-btn-primary"}" id="start-btn">${hasSave ? "NEW RUN (NORMAL)" : "▶ START GAME"}</button>
        <button class="btn menu-btn-hard ${canHard ? "" : "menu-btn-impossible-locked"}" id="hard-btn" ${canHard ? "" : 'disabled'}>
          ⚔ HARD MODE${canHard ? "" : '<span class="menu-impossible-lock">🔒 Complete a run to unlock</span>'}
        </button>
        <button class="btn menu-btn-impossible ${canImpossible ? "" : "menu-btn-impossible-locked"}" id="impossible-btn" ${canImpossible ? "" : 'disabled'}>
          ☠ IMPOSSIBLE MODE${canImpossible ? "" : '<span class="menu-impossible-lock">🔒 Beat Hard to unlock</span>'}
        </button>
      </div>
      <div class="menu-nav-row">
        <button class="btn ghost btn-sm" id="ach-btn">ACHIEVEMENTS</button>
        <button class="btn ghost btn-sm" id="hof-btn">HALL OF FAME</button>
      </div>
      <a class="btn ghost btn-sm menu-back-link" id="back-site-btn" href="https://loldodgegame.com">← MORE LoL GAMES</a>
    `;

    if (hasSave) {
      (this.root.querySelector("#continue-btn") as HTMLButtonElement).addEventListener("click", () => {
        const saved = this.game.loadSavedRun();
        if (!saved) { this.buildButtons(); return; }
        this.game.runState = saved;
        this.game.rng = new RNG(saved.seed);
        this.game.achievements.onRunStart();
        this.game.sceneManager.transition(new MapScene(this.game));
      });
    }

    (this.root.querySelector("#start-btn") as HTMLButtonElement).addEventListener("click", () => {
      this.game.clearSave();
      this.game.startRun(randomSeed(), "normal");
      this.game.sceneManager.transition(new ChampionSelectScene(this.game));
    });

    const hardBtn = this.root.querySelector("#hard-btn") as HTMLButtonElement;
    if (canHard) {
      hardBtn.addEventListener("click", () => {
        this.game.clearSave();
        this.game.startRun(randomSeed(), "hard");
        this.game.sceneManager.transition(new ChampionSelectScene(this.game));
      });
    } else {
      hardBtn.addEventListener("click", (e) => e.preventDefault());
    }

    const impossibleBtn = this.root.querySelector("#impossible-btn") as HTMLButtonElement;
    if (canImpossible) {
      impossibleBtn.addEventListener("click", () => {
        this.game.clearSave();
        this.game.startRun(randomSeed(), "impossible");
        this.game.sceneManager.transition(new ChampionSelectScene(this.game));
      });
    } else {
      impossibleBtn.addEventListener("click", (e) => e.preventDefault());
    }

    (this.root.querySelector("#ach-btn") as HTMLButtonElement).addEventListener("click", () => {
      this.game.sceneManager.transition(new AchievementsScene(this.game));
    });

    (this.root.querySelector("#hof-btn") as HTMLButtonElement).addEventListener("click", () => {
      this.game.sceneManager.transition(new HallOfFameScene(this.game));
    });
  }

  exit(): void {
    this.root.remove();
  }

  update(_dt: number): void {}
  render(_ctx: CanvasRenderingContext2D): void {}
}
